import React, { Component } from 'react'
import { Panel, Container, Button, List, SearchField, Toolbar, Menu, MenuItem, Label } from '@sencha/ext-modern'
import { compose } from 'redux'
import { connect } from 'react-redux'
import escapeRegExp from 'escape-string-regexp'
import Message from 'Tyan/components/Message'
import AppTitle from './AppTitle'
import { doGetAllSignedTaskList, doSubmitTask } from '../../reducers/actions'
import ListItem from './ListItem'

Ext.require([
  'Ext.dataview.listswiper.ListSwiper'
])

const style = {
  outer: {
    backgroundColor: "#f5f5f5",
    paddingTop: "10px",
    paddingBottom: "10px"
  },
  innerContainer: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    margin: "10px",
  },
  titleContainer: {
    borderBottom: "1px solid #f5f5f5",
  },
  titleSmall: {
    margin: 0,
    fontSize: "14px",
  },
  contentContainer: {
    padding: "10px",
    fontSize: "12px",
    color: '#838484'
  },
  checked: {
    color: "#37a1f2",
    paddingTop: "5px"
  },
  unchecked: {
    color: "#959595",
    paddingTop: "5px"
  }
}

class MySignedTask extends Component {
  state = {
    query: '',
    loading: false,
    errorMessage: null,
    selectedTaskType: '全部',
  }

  componentDidMount() {
    const { } = this.state
    this.GetAllSignedTaskList()
  }

  GetAllSignedTaskList = () => {
    const { doGetAllSignedTaskList } = this.props
    doGetAllSignedTaskList({
      onRequest: () => {
        this.setState({ loading: true })
      },
      onEnd: ({ errorMessage, allTaskList }) => {
        errorMessage && this.setState({ loading: false, errorMessage }) ||
          this.setState({ loading: false, allTaskList })
      }
    })
  }

  search = (field, value) => {
    this.setState({ query: value })
  }

  handleSelectType = (e) => {
    this.setState({ selectedTaskType: e._text })
  }

  handleChildTap = ({ id, type }) => {
    switch (type) {
      case '忘刷卡申请':
        location.hash = `QYWX/ForgetSwipeCardApply/${id}`
        break
      case '加班申请':
        location.hash = `QYWX/OverTimeApply/${id}`
        break
      case '请假申请':
        location.hash = `QYWX/OutApply/${id}`
        break
      // case '预支申请':
      //   location.hash = `QYWX/AdvanceApply/${id}`
      //   break
      // case '报支申请':
      //   location.hash = `QYWX/ExpenseApply/${id}`
      //   break
      // case '请购申请':
      //   location.hash = `QYWX/RequisitionApply/${id}`
      //   break
      // case '采购申请':
      //   location.hash = `QYWX/PurchaseApply/${id}`
      //   break
    }
  }

  handleSearchClick = () => {
    const { showSearchForPhone } = this.state
    this.setState({ showSearchForPhone: !showSearchForPhone })
  }

  handleChange = (value) => {
    this.setState({ query: value })
  }

  render() {
    const { errorMessage, allTaskList, selectedTaskType, showSearchForPhone, query } = this.state
    const panelProps = {
      height: "100%",
      margin: '0 0 0 0',
      padding: '0 0 0 0'
    }
    if (errorMessage) {
      return <Message text="数据加载失败" subText={errorMessage} />
    } else if (!allTaskList) {
      return <Message text="数据加载中..." />
    }
    let newAllTaskList = allTaskList
    if (selectedTaskType !== '全部')
      newAllTaskList = newAllTaskList.filter(item => item.title === selectedTaskType)
    if (query) {
      const match = new RegExp(escapeRegExp(query), 'i')
      newAllTaskList = newAllTaskList.filter(item => match.test(item.number) || match.test(item.title) || match.test(item.name))
    }
    return (
      <Panel shadow layout="vbox" {...panelProps} >
        <Container layout="fit" flex={0}>
          <AppTitle
            showSearchForPhone={showSearchForPhone}
            onClick={this.handleSearchClick}
            onSearch={this.search}
            allTaskList={allTaskList}
            type="签核"
            onSelectType={this.handleSelectType}
            selectedTaskType={selectedTaskType}
          />
        </Container>
        <Container layout="vbox" flex={4} scrollable style={style.outer} >
          <ListItem listData={newAllTaskList} totalCount={newAllTaskList.length} handleChildTap={this.handleChildTap} />

          {/* {this.LoadTaskList(allTaskList)} */}
        </Container>
      </Panel>
    )
  }
}

const mapStateToProps = ({ }) => ({})

export default compose(
  connect(mapStateToProps, { doGetAllSignedTaskList, doSubmitTask }),
)(MySignedTask)
